<template>
  <section>
    <b-nav tabs>
      <b-nav-item v-bind:to="{ name: 'account/student/index' }" exact
        >Ringkasan</b-nav-item
      >
      <b-nav-item v-bind:to="{ name: 'account/student/profile' }" exact
        >Data Diri</b-nav-item
      >
      <b-nav-item
        v-bind:to="{ name: 'account/student/attend' }"
        exact
        v-if="
          student.branch.id != 19 &&
          student.branch.id != 20 &&
          student.branch.id != 22 &&
          student.branch.id != 23 &&
          student.branch.id != 24 &&
          student.branch.id != 25 &&
          student.branch.id != 26
        "
        >Laporan Kehadiran</b-nav-item
      >
      <b-nav-item
        v-bind:to="{ name: 'account/student/score' }"
        v-bind:active="
          ['score', 'tryout', 'recommendation'].some((value) =>
            this.$route.path.includes(value)
          )
        "
        >Laporan Nilai</b-nav-item
      >
      <b-nav-item v-bind:to="{ name: 'account/student/psycho-test' }" exact
        >Laporan Psikotest</b-nav-item
      >
      <b-nav-item
        v-bind:to="{ name: 'account/student/utbk' }"
        exact
        v-if="student.btaGrade.level >= 12"
        >Simulasi Pilihan Prodi SNBT</b-nav-item
      >
      <b-nav-item exact v-if="false">Pesan</b-nav-item>
    </b-nav>
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: "AccountStudentLayout",
  data() {
    return {
      student: { grade: {} },
    };
  },
  created() {
    this.axios
      .get(process.env.API_URL + "/student/profile")
      .then((response) => {
        this.student = response.data.data;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/account/student/Layout.vue